import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { UserProfileMenuComponent } from './components/user-profile-menu/user-profile-menu.component';
import { HeaderComponent } from './header.component';

@NgModule({
  declarations: [HeaderComponent, UserProfileMenuComponent],
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    DragDropModule,
    MatIconModule,
    RouterModule,
    MatTooltipModule,
    MatMenuModule
  ],
  exports: [HeaderComponent]
})
export class HeaderModule {}
